export default "__VITE_ASSET__CEAuxZiv__"